import find from 'lodash/find.js';
import isEmpty from 'lodash/isEmpty.js';
import map from 'lodash/map.js';
import { updateChoiceSuccess } from '@gcc/configurator';
import { mapChoicesToSkus } from '../../api/skuMapperApi';
import {
  UPDATE_SKUMAP,
  UPDATE_SKUMAP_STARTED,
  UPDATE_SKUMAP_FAILED,
  UPDATE_SKUMAP_FINISHED,
} from '../actionTypes';
import getSelectedChoices from './_getSelectedChoices';
import doAnyOptionsHaveErrors from './_doAnyOptionsHaveErrors';
import { CUSTOM_CONFIG_BASED } from '../../utils/pipFiguratorType';

// action creators

const updateSkuMapFailed = (newSkus) => ({
  type: UPDATE_SKUMAP_FAILED,
  newSkus,
});

const getSkuMapFinished = () => ({
  type: UPDATE_SKUMAP_FINISHED,
});

const updateSkuMap = (newSkus) => ({
  type: UPDATE_SKUMAP,
  newSkus,
});

const clearSkuMap = () => ({
  type: UPDATE_SKUMAP,
  newSkus: {
    sku: '',
    skuType: '',
    hash: '',
    subSkus: [],
    isValid: true,
    isSpecialOrder: false,
    errors: [],
    allSkus: [],
  },
});

const clearState = (message) => (dispatch) => {
  dispatch(updateSkuMapFailed(message));
};

// thunks
const getSkuMapStarted = () => (dispatch, getState) => {
  const { options } = getState().configurator;
  const configurationError = doAnyOptionsHaveErrors(options);

  dispatch({
    type: UPDATE_SKUMAP_STARTED,
    configurationError,
  });
};

export const getSku = () => (dispatch, getState) => {
  const {
    configurator: { options, choices },
    config: { productId, siteId },
    thdStoreInfo: { storeNumber },
  } = getState();

  const selectedChoices = getSelectedChoices(options, choices);

  const selections = map(selectedChoices, (choice) => {
    const option = options[choice.optionId];

    return {
      choiceId: choice.id,
      choiceValue: choice.shortLabel,
      choiceName: choice.internalName,
      optionId: choice.optionId,
      optionTags: option.tags,
      optionName: option.internalName,
    };
  });

  return mapChoicesToSkus(siteId, productId, storeNumber, selections);
};

const updatePrimarySku = (skuMap) => (dispatch) => {
  let sku = null;
  let allSkus = [];

  const nonStoreSkus = skuMap.skus.filter((xSku) => xSku.skuType !== 'StoreSku');
  allSkus = skuMap.skus.map((sk) => {
    if (sk.subSkus.length) return sk.skuType;
    return null;
  });
  // Find the primary sku
  if (nonStoreSkus.length > 0) {
    const prod = nonStoreSkus.find((xSku) => xSku.skuType === 'HomeDepot_OMSID');
    sku = prod || nonStoreSkus[0];
  }

  if (!sku) {
    dispatch(clearSkuMap);
  }

  const newSku = {
    ...sku,
    hash: skuMap.hash,
    errors: skuMap.errors,
    isValid: skuMap.isValid,
    allSkus,
  };
  dispatch(updateSkuMap(newSku));
};

const updateStoreSku = (skuMap) => (dispatch, getState) => {
  const storeSku = skuMap.skus.find((sSku) => sSku.skuType === 'StoreSku');
  let sku = '';
  if (!isEmpty(storeSku) && !isEmpty(storeSku.sku)) {
    // eslint-disable-next-line prefer-destructuring
    sku = storeSku.sku;
  }

  const {
    configurator: { choices },
  } = getState();
  const storeSkuChoice = find(choices, (xItem) => xItem.tags.includes('store-sku'));
  if (storeSkuChoice) {
    dispatch(updateChoiceSuccess(storeSkuChoice.optionId, storeSkuChoice.id, sku));
  }
};

// public
const getSkuMap = () => (dispatch, getState) => {
  const { pipfiguratorType } = getState().product.details.attributes || '';
  if (!pipfiguratorType || pipfiguratorType !== CUSTOM_CONFIG_BASED) {
    dispatch(getSkuMapStarted());
    return dispatch(getSku())
      .then(
        (newSkus) => {
          dispatch(updatePrimarySku(newSkus));
          dispatch(updateStoreSku(newSkus));
        },
        (error) => {
          const newSkusError = error.response.data;
          if (error.response.status === 404) {
            dispatch(clearSkuMap());
          } else {
            dispatch(clearState(newSkusError));
          }
        }
      )
      .then(() => {
        dispatch(getSkuMapFinished());
      });
  }
  return Promise.resolve(dispatch(clearSkuMap()));
};

export default getSkuMap;
